import { MantineProvider as BaseMantineProvider, createTheme } from '@mantine/core';
import { PropsWithChildren } from 'react';

/* https://mantine.dev/styles/unstyled/
 * Not importing this makes the entire library a headless component library */
import '@mantine/core/styles.css';

const theme = createTheme({
	/** Put your mantine theme override here */
});

export const MantineProvider = ({ children }: PropsWithChildren) => {
	return <BaseMantineProvider theme={theme}>{children}</BaseMantineProvider>;
};
